import { pageName } from 'utils/copy';

const debug = typeof location !== 'undefined' && new URLSearchParams(location.search).has('powdebug');

function log(message, action, data) {
	if (!debug) return;
	const inlineData = Object.entries(data || {}).filter(([, v]) => v).map(([key, value]) => `\x1b[37m${key}\x1b[0m: \x1b[36m${value}\x1b[0m`).join(', ');
	// Note: window.console to avoid it being removed from prod builds, because of the drop_console terser option in webpack
	window.console.log(
		[
			'[PowDebug]',
			`[${new Date().toLocaleTimeString()}]`,
			message,
			action && `\x1b[33m${action}\x1b[0m`,
			inlineData && `(${inlineData})`,
		].filter(Boolean).join(' ')
	);
}

export function track(category, action, label, extra) {
	log('fired GA event', action, { category, label, ...extra });

	window.gtag?.('event', action, {
		event_category: '',
		event_label: label ?? '',
		...extra,
	});

	dataLayer.push({ event_action: action, movie: extra?.movie });
}

export function trackPageView(page) {
	log('fired GA page view', page?.id);
	const pageTitle = pageName(page?.id);
	window.gtag?.('event', 'page_view', { page_title: pageTitle, page_path: page?.path });
	if (window.dataLayer) {
		setTimeout(() => window.dataLayer.push({ event: '3secDwell' }), 3000);
	}
	// , movie
	dataLayer.push({ event: 'pageview', page_type: pageTitle, page_name: document.title });
}

export function trackLanding(page) {
	let name = pageName(page?.id);

	// Why do we have an exception for home ? Surely it is recognizable enough
	const landingName = name === 'Home' ? 'Homepage' : name;
	window.dataLayer.push({
		event: 'Landing',
		site: {
			name: landingName,
			market: __REGION__.toUpperCase(),
			template: landingName,
		},
		page: {
			name: landingName,
			type: landingName,
		},
		movie: {
			name: null,
			release_date: null,
			imdb_id: null,
			genre: {
				essence_genre: null,
				genre_1: null,
				content_genome: 'N/A',
				fs_o: undefined,
			}
		}
	});

	trackPageView(page);

	track('landing', 'landing', name);
	const navigationTimings = performance.getEntriesByType('navigation')[0];
	track('landing', 'timing_complete', `${Math.max(0, ((navigationTimings.loadEventEnd || performance.now()) - navigationTimings.responseEnd) / 1000).toFixed(2)}s`);
	const pixelRatio = window.devicePixelRatio || 1;
	track('landing', 'screen-pixel-dimensions', `${window.innerWidth * pixelRatio}x${window.innerHeight * pixelRatio}`);
}
